<template>
    <ArrivalDeclarationCard
        ref="arrivalDeclarationCard"
        :arrival-declaration="arrivalDeclaration"
        :arrival-declaration-statuses="arrivalDeclarationStatuses"
        :currencies="currencies"
        :suppliers="suppliers"
        :warehouses="warehouses"
        v-model:selected-currency="selectedCurrency"
        v-model:selected-status="selectedStatus"
        :selected-warehouse="selectedWarehouse"
        :selected-supplier="selectedSupplier"
        @update:currency-rate="arrivalDeclaration.currency_rate = $event"
        @edit="editArrivalDeclaration"
        @delete="deleteArrivalDeclaration"
    />
    <ProductItemTable
        :arrival-declaration="arrivalDeclaration"
        :currency-uuid="selectedCurrency?.uuid ?? ''"
        :currency-rate="selectedCurrency?.rate ?? ''"
        :main-currency="mainCurrency"
        :currencies="currencies"
        :selected-warehouse="selectedWarehouse"
    />
</template>

<script>
import ArrivalDeclarationCard from './cards/ArrivalDeclarationCard.vue';
import ProductItemTable from './cards/ProductItemTableCard.vue';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator.js';
export default {
    name: 'EditArrivalDeclarationPage',
    components: {
        ArrivalDeclarationCard,
        ProductItemTable
    },
    data() {
        return {
            arrivalDeclaration: null,
            selectedCurrency: null,
            selectedStatus: null,
            selectedWarehouse: null,
            selectedSupplier: null,
            arrivalDeclarationStatuses: [],
            currencies: [],
            suppliers: [],
            warehouses: []
        }
    },
    methods: {
        async fetchCurrencies() {
            await httpClient.get('/list/currencies').then((response) => {
                this.currencies = response.data.data
            })
        },
        async fetchArrivalDeclaration() {
            await httpClient.get(`/management/arrival-declarations/${this.$route.params.arrivalDeclarationUuid}`).then(response => {
                this.arrivalDeclaration = response.data.data;
            })
        },
        async fetchArrivalDeclarationStatuses() {
            await httpClient.get(`/management/arrival-declaration-statuses`).then(response => {
                this.arrivalDeclarationStatuses = response.data.data
            })
        },
        async fetchSuppliers() {
            await httpClient.get(`/management/suppliers`).then(response => {
                this.suppliers = response.data.data
            })
        },
        async fetchWarehouses() {
            await httpClient.get(`/management/warehouses`).then(response => {
                this.warehouses = response.data.data
            })
        },
        async editArrivalDeclaration() {
            await httpClient.put(`/management/arrival-declarations/${this.arrivalDeclaration.uuid}/update-status`, {
                status_id: this.selectedStatus.id
            }).then(response => {
                this.arrivalDeclaration.arrival_declaration_status = response.data.data.status;

                new MessageNotificator().success(this.$t('alerts.success'));
            })

            await httpClient.patch(`/management/arrival-declarations/${this.arrivalDeclaration.uuid}`, {
                currency_uuid: this.selectedCurrency.uuid,
                currency_rate: this.arrivalDeclaration.currency_rate
            })
        },
        async deleteArrivalDeclaration() {
            new MessageNotificator().confirm(this.$t("alerts.confirm_delete", {
                value: this.$t("labels.arrival_declaration")
            }), async () => {
                await httpClient.delete(`/management/arrival-declarations/${this.arrivalDeclaration.uuid}`).then((response) => {
                    this.$router.push({ name: 'IndexArrivalDeclarationPage' })
                })
            })
        }
    },
    computed: {
        mainCurrency() {
            return this.currencies.find(currency => currency.main === 1)
        }
    },
    async mounted() {
        await this.fetchArrivalDeclaration();
        await this.fetchCurrencies();
        await this.fetchArrivalDeclarationStatuses();
        await this.fetchSuppliers();
        await this.fetchWarehouses();

        this.selectedCurrency = this.currencies.find(currency => currency.uuid === this.arrivalDeclaration.currency_uuid);
        this.selectedStatus = this.arrivalDeclarationStatuses.find(status => status.uuid === this.arrivalDeclaration.arrival_declaration_status.uuid);
        this.selectedWarehouse = this.warehouses.find(warehouse => warehouse.id === this.arrivalDeclaration.warehouse_id);
        this.selectedSupplier = this.suppliers.find(supplier => supplier.id === this.arrivalDeclaration.supplier_id);
    }
}
</script>
